export default "__VITE_ASSET__Kp02mmsR__"